import { InputFieldConfig } from '../../../../../types';
import { StudentState } from '../../../../../store/student/types';

type Fields = {
  courseFeeDepositReqd: string;
  courseFeeDeposit: number;
  courseFeeDepositDate: string;
  courseFeeDepositNotReqdReason: string;
  accomDepositReqd: string;
  accomDeposit: number;
  accomDepositDate: string;
};

type Visible = Record<
  | 'courseFeeDepositReqd'
  | 'courseFeeDeposit'
  | 'courseFeeDepositDate'
  | 'courseFeeDepositNotReqdReason'
  | 'accomDepositReqd'
  | 'accomDeposit'
  | 'accomDepositDate',
  boolean
>;

type Mandatory = Record<
  | 'courseFeeDepositReqd'
  | 'courseFeeDeposit'
  | 'courseFeeDepositDate'
  | 'courseFeeDepositNotReqdReason'
  | 'accomDepositReqd'
  | 'accomDeposit'
  | 'accomDepositDate',
  boolean
>;

export function getPageStatus(
  config: StudentState['config'],
  fields: Fields,
): {
  complete: boolean;
  visible: Visible;
} {
  const {
    courseFeeDepositReqd,
    courseFeeDeposit,
    courseFeeDepositDate,
    courseFeeDepositNotReqdReason,
    accomDepositReqd,
    accomDeposit,
    accomDepositDate,
  } = fields;

  const {
    DepositPaid: courseFeeDepositReqdConfig,
    DepositAmount: courseFeeDepositConfig,
    DepositDate: courseFeeDepositDateConfig,
    DepositReason: courseFeeDepositReasonConfig,
    AccommodationDepositPaid: accomDepositReqdConfig,
    AccommodationDepositAmount: accomDepositConfig,
    AccommodationDepositDate: accomDepositDateConfig,
  }: {
    DepositPaid: InputFieldConfig;
    DepositAmount: InputFieldConfig;
    DepositDate: InputFieldConfig;
    DepositReason: InputFieldConfig;
    AccommodationDepositPaid: InputFieldConfig;
    AccommodationDepositAmount: InputFieldConfig;
    AccommodationDepositDate: InputFieldConfig;
  } = config.Checklist.Finances.Page1;

  const visible: Visible = {
    courseFeeDepositReqd: courseFeeDepositReqdConfig?.visible ?? true,
    courseFeeDeposit: (courseFeeDepositConfig?.visible ?? true) && courseFeeDepositReqd === 'Yes',
    courseFeeDepositDate: (courseFeeDepositDateConfig?.visible ?? true) && courseFeeDepositReqd === 'No',
    courseFeeDepositNotReqdReason:
      (courseFeeDepositReasonConfig?.visible ?? true) && courseFeeDepositReqd === 'No - Not Required',
    accomDepositReqd: accomDepositReqdConfig?.visible ?? true,
    accomDeposit: (accomDepositConfig?.visible ?? true) && accomDepositReqd === 'Yes',
    accomDepositDate:
      (accomDepositDateConfig?.visible ?? true) && accomDepositReqd === 'Not yet - I plan on paying one',
  };

  const mandatory: Mandatory = {
    courseFeeDepositReqd: courseFeeDepositReqdConfig?.mandatory ?? true,
    courseFeeDeposit: courseFeeDepositConfig?.mandatory ?? true,
    courseFeeDepositDate: courseFeeDepositDateConfig?.mandatory ?? true,
    courseFeeDepositNotReqdReason: courseFeeDepositReasonConfig?.mandatory ?? true,
    accomDepositReqd: accomDepositReqdConfig?.mandatory ?? true,
    accomDeposit: accomDepositConfig?.mandatory ?? true,
    accomDepositDate: accomDepositDateConfig?.mandatory ?? true,
  };

  // prettier-ignore
  const complete: boolean =
    (!visible.courseFeeDepositReqd || !mandatory.courseFeeDepositReqd || courseFeeDepositReqd !== '') &&
    (!visible.courseFeeDeposit || !mandatory.courseFeeDeposit || courseFeeDeposit !== 0) &&
    (!visible.courseFeeDepositDate || !mandatory.courseFeeDepositDate || courseFeeDepositDate !== '') &&
    (!visible.courseFeeDepositNotReqdReason || !mandatory.courseFeeDepositNotReqdReason || courseFeeDepositNotReqdReason !== '') &&
    (!visible.accomDepositReqd || !mandatory.accomDepositReqd || accomDepositReqd !== '') &&
    (!visible.accomDeposit || !mandatory.accomDeposit || accomDeposit !== 0) &&
    (!visible.accomDepositDate || !mandatory.accomDepositDate || accomDepositDate !== '')

  return {
    complete,
    visible,
  };
}
